// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  .sticcky {
    position: sticky;
    top: 0;
    width: 100%;
    transition: all 0.5s ease;
    animation: smoothScroll 1s forwards;
    z-index: 50;
  }

  .sticceky {
    position: fixed;
    top: 0;
    width: 100%;
    transition: all 0.5s ease;
    animation: smoothScroll 1s forwards;
    z-index: 50;
  }

  #scroll-container {
    scroll-behavior: smooth; /* For smooth scrolling effect */
  }`, "",{"version":3,"sources":["webpack://./src/pages/previewPage/dashboardMobilePreview/header.css"],"names":[],"mappings":";EACE;IACE,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,yBAAyB;IACzB,mCAAmC;IACnC,WAAW;EACb;;EAEA;IACE,eAAe;IACf,MAAM;IACN,WAAW;IACX,yBAAyB;IACzB,mCAAmC;IACnC,WAAW;EACb;;EAEA;IACE,uBAAuB,EAAE,gCAAgC;EAC3D","sourcesContent":["\r\n  .sticcky {\r\n    position: sticky;\r\n    top: 0;\r\n    width: 100%;\r\n    transition: all 0.5s ease;\r\n    animation: smoothScroll 1s forwards;\r\n    z-index: 50;\r\n  }\r\n\r\n  .sticceky {\r\n    position: fixed;\r\n    top: 0;\r\n    width: 100%;\r\n    transition: all 0.5s ease;\r\n    animation: smoothScroll 1s forwards;\r\n    z-index: 50;\r\n  }\r\n\r\n  #scroll-container {\r\n    scroll-behavior: smooth; /* For smooth scrolling effect */\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
